import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import UserContext from '../context/UserContext'
import arraste from '../imgs/arraste.svg'
import { Main, Container, Voltar } from '../styles/GlobalStyled.js'

export default function Calibragem() {
  const { tamCartao, setTamCartao } = useContext(UserContext)
  return (
    <Main>
      <Container>
        <Cartao largura={`${tamCartao}px`}></Cartao>

        <Botoes>
          <img src={arraste} alt="arraste" />
          <input
            type="range"
            name="tamanho"
            min="100"
            max="350"
            step="1"
            value={tamCartao}
            onChange={(e) => setTamCartao(e.target.value)}
          />
          <Link to={'/medicao-com-anel'}>
            <button>Pronto, já calibrei!</button>
          </Link>
          <Link to={'/instrucao-calibragem'}>
            <Voltar>Ops, não lembro como faz.</Voltar>
          </Link>
        </Botoes>
      </Container>
    </Main>
  )
}

const Cartao = styled.div`
  width: 90vw;
  height: ${(props) => props.largura};
  border-top: 3px solid #642c1c;
  border-bottom: 3px solid #642c1c;
  background-color: rgba(102, 176, 180, 0.5);
  position: absolute;
  top: 100px;

  @media (min-width: 1300px) {
    top: 5%;
  }
`

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 5px;
    background: rgba(102, 176, 180, 0.3);
    outline: none;
    width: 80vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #642c1c;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #642c1c;
    cursor: pointer;
  }

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 20px;
    background-color: #66b0b4;
    background-size: cover;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 99px;
    border: 1px solid #d9bf9c;
    cursor: pointer;
  }

  img {
    max-width: 150px;
    margin-left: -40vw;
    margin-bottom: -30px;
  }
`
